export default "__VITE_ASSET__BMZjE9Zq__"